module.exports = __webpack_public_path__ + "static/img/3.d8e3a91.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting584/images/3.png
// module id = Dc1c
// module chunks = 4